// ==========================================================================
// Weather Service - Weather API calls
// GET /api/user/weather (requires Bearer token, confirmed location)
// ==========================================================================

import api from '@/lib/axios';
import type { WeatherData, WeatherResponse } from '@/types/weather.types';

/**
 * Get current weather and 7-day forecast for the user's confirmed location
 */
export async function getWeather(): Promise<WeatherData> {
  const response = await api.get<WeatherResponse>('/user/weather');
  return response.data.data;
}
